import { DeserializeHtml } from '../../../../slatePlugins/slatePlugins.types';
import { ELEMENT_ICON } from './defaults';

const deserializeIconElement = (el) => {
  if (el && el?.classList?.contains('icon-container')) {
    const nodeIconKey = typeof el?.getAttribute === 'function' && el.getAttribute('data-icon-key');

    return { type: ELEMENT_ICON, iconKey: nodeIconKey };
  }
  return undefined;
};

export const deserializeIcon = (): DeserializeHtml => {
  return {
    element: [
      {
        type: ELEMENT_ICON,
        deserialize: deserializeIconElement,
        withoutChildren: true,
      },
    ],
  };
};
